<template>
  <footer class="relative z-10 w-full max-w-7xl mx-auto mt-24 px-6 pb-12">
    <!-- Subtle Gradient Divider -->
    <div
      class="relative w-full h-px bg-linear-to-r from-transparent via-white/15 to-transparent mb-12"
    />

    <div
      class="flex flex-col lg:flex-row gap-12 justify-between items-start lg:items-center"
    >
      <!-- Legal Links (Improved legibility) -->
      <div
        class="flex flex-col sm:flex-row gap-8 order-2 lg:order-1 w-full sm:w-auto text-center sm:text-left"
      >
        <NuxtLink
          to="/privacy"
          class="text-xs font-medium tracking-wider text-white/50 transition-colors hover:text-brand"
        >
          Privacy Policy
        </NuxtLink>
        <NuxtLink
          to="/terms"
          class="text-xs font-medium tracking-wider text-white/50 transition-colors hover:text-brand"
        >
          Terms of Service
        </NuxtLink>
      </div>

      <!-- Social Links (Modern with Tooltips) -->
      <div
        class="flex flex-col items-center gap-6 order-1 lg:order-2 self-center lg:self-auto"
      >
        <!-- <PebbleAppHomeLogo class="h-5 opacity-50 hover:opacity-100 transition-opacity" /> -->

        <div class="flex gap-4 items-center">
          <!-- Wrap the 'a' tag within the Tooltip component -->
          <PebbleAppTooltip
            v-for="social in socialLinks"
            :key="social.label"
            :text="social.label"
            position="top"
          >
            <a
              :href="social.href"
              target="_blank"
              rel="noopener noreferrer"
              class="group size-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center transition-all duration-300 hover:bg-brand/10 hover:border-brand/40 hover:-translate-y-1"
            >
              <component
                :is="social.icon"
                class="size-4 text-white/60 group-hover:text-brand transition-colors"
                stroke-width="2"
              />
            </a>
          </PebbleAppTooltip>
        </div>
      </div>

      <!-- Copyright & Version -->
      <div
        class="flex flex-col items-center lg:items-end gap-1.5 order-3 w-full lg:w-auto text-center lg:text-right"
      >
        <span class="text-xs font-semibold tracking-wide text-white/50">
          Version 1.0.4
        </span>
        <span class="text-[11px] font-mono text-white/30 tracking-wide">
          © 2026 Pebble Inc • All rights reserved
        </span>
      </div>
    </div>

    <!-- Bottom Decorative Accent -->
    <div class="mt-12 flex justify-center">
      <div class="h-1 w-12 rounded-full bg-white/10" />
    </div>
  </footer>
</template>

<script lang="ts" setup>
import {
  Twitter,
  Instagram,
  Youtube,
  Clapperboard,
  Facebook,
} from "lucide-vue-next";

const socialLinks = [
  {
    label: "YouTube",
    icon: Youtube,
    href: "https://youtube.com/@trypebblenow?si=SB-BZUx3FvBZyVH1",
  },
  {
    label: "X (Twitter)",
    icon: Twitter,
    href: "https://x.com/trypebble?s=21&t=v53AHsB2zFSwKBeN-AU63g",
  },
  {
    label: "Instagram",
    icon: Instagram,
    href: "https://www.instagram.com/trypebblenow?igsh=eWdtZTU2NmR2enJ1",
  },
  {
    label: "TikTok",
    icon: Clapperboard,
    href: "https://www.tiktok.com/@trypebblenow?_r=1&_t=ZS-97G9k2Nh7bU",
  },
  {
    label: "Facebook",
    icon: Facebook,
    href: "https://www.facebook.com/share/1BLSQKD2F7/?mibextid=wwXIfr",
  },
];
</script>

<style scoped>
footer {
  font-family: "Inter Tight", sans-serif;
}
</style>
